import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getProfileUpdateRequirements,
  patchProfileUpdate,
  ProfileUpdatePayload,
} from "@/service/_apiService"

export const PROFILE_UPDATE_REQUIREMENTS_KEY = ["profileUpdateRequirements"]

/**
 * Obtiene la configuración de la organización y el estado actual del usuario
 * respecto a la actualización de perfil.
 * Solo se ejecuta si hay un token de sesión activo.
 */
export const useProfileUpdateRequirements = (enabled = true) => {
  return useQuery({
    queryKey: PROFILE_UPDATE_REQUIREMENTS_KEY,
    queryFn: getProfileUpdateRequirements,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 1,
  })
}

/**
 * Mutación para:
 *  a) actualizar los datos del perfil del usuario, o
 *  b) diferir la actualización (`remind_later: true`)
 *
 * Tras éxito invalida el cache del usuario y de los requirements.
 */
export const usePatchProfileUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ["patchProfileUpdate"],
    mutationFn: (data: ProfileUpdatePayload) => patchProfileUpdate(data),
    onSuccess: () => {
      // Forzar revalidación del usuario para que `required_update` se actualice
      queryClient.invalidateQueries({ queryKey: ["getUser"] })
      queryClient.invalidateQueries({ queryKey: PROFILE_UPDATE_REQUIREMENTS_KEY })
    },
    onError: (error) => {
      console.error("Error al actualizar el perfil:", error)
    },
  })
}
